import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import TextIcon from '../../../../../../icons/TextIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerTextControlsButton = ({ className, onClick, active }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<TextIcon />}
      title="Text"
      onClick={onClick}
    />
  );
};

CardDesignerTextControlsButton.propTypes = propTypes;

export default CardDesignerTextControlsButton;
